import { FAQConstants } from "utils/constants";

/** A Markdown link: `[text](address)`, its text without brackets and its address without spaces. */
export const MarkdownLinkPattern = /\[([^[\]\n]+)\]\(([^()\s]+)\)/g;

const FaqHost = new URL(FAQConstants.FAQUrl).hostname;

/** The address of an FAQ article, or nothing: https on the FAQ's own host, no port and no user. */
export const faqArticleUrl = (address: string): string | undefined => {
  try {
    const url = new URL(address);
    const isFaq = url.protocol === "https:" && url.hostname === FaqHost && !url.port && !url.username && !url.password;
    return isFaq ? url.href : undefined;
  } catch {
    return undefined;
  }
};

// An article slug as the FAQ writes them. The address comes from a model that reads customer data, so
// anything else in its place (no letter, say, like a personal number) is not tracked: a path is no
// promise it names an article.
const SlugPattern = /^(?=[a-z0-9-]*[a-z])[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** The article's slug, the last part of its path, when it looks like one: Wint's own content, fit for tracking. */
export const faqArticleSlug = (address: string): string | undefined => {
  const url = faqArticleUrl(address);
  const slug = url ? new URL(url).pathname.split("/").filter(Boolean).at(-1) : undefined;
  return slug && slug.length <= 100 && SlugPattern.test(slug) ? slug : undefined;
};

/** The slugs of the FAQ articles an answer links to, in order and without repeats. */
export const citedFaqArticles = (markdown: string): string[] => [
  ...new Set(
    Array.from(markdown.matchAll(MarkdownLinkPattern)).flatMap(([, , address]) => {
      const slug = faqArticleSlug(address);
      return slug ? [slug] : [];
    })
  ),
];
